import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: true
};

export const salesSlice = createSlice({
  name: 'shop-admin-drawer',
  initialState,
  reducers: {
    toggleDrawer: (state) => {
      state.isOpen = !state.isOpen;
    }
  }
});

export const { toggleDrawer } = salesSlice.actions;

export default salesSlice;
